import axios from 'axios';
import React, { useState } from 'react';
import {Modal,Button} from 'react-bootstrap';
import './DeclineModal.css'
import swal from 'sweetalert';

const DeclineModal = (props) => {

  const [text, setText] = useState();

  function handleChange(postId) {
    const formData = new FormData();

    formData.append("postId", postId);
    formData.append("text", text);

    axios
      .post(`/api/admin/fan/group/deline/nofification/${postId}`, formData)
      .then((res) => {
        if (res.status === 200) {
          props.declineData(true, false);
          swal("Welcome", res.data.message, "success");
        }
      });
  }

    return (
        <div>
             <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
  
      <Modal.Body className='bg-dark' style={{ border:'2px solid gold',borderRadius:'5px' }}>
      <div className="d-flex justify-content-end" style={{ cursor:'pointer' }} onClick={props.onHide}>
      <i className="fa-solid fa-xmark text-warning"></i>
      </div>
       <div>
     
<div className="my-3 decline-form">

  <textarea className="form-control" placeholder='Type reason for decline' rows="3" onChange={(event) => { setText(event.target.value) }} style={{ backgroundColor:'#484848',border:'none' }}></textarea>
</div>

<div className="decline-btns d-flex justify-content-end">
  <div>
    <button className='btn btn-outline-warning px-4'onClick={props.onHide}>Cancel</button>
    <button className='btn btn-warning mx-2 px-4' onClick={()=>handleChange(props.postId)}>Send</button>
  </div>
</div>
       </div>
      </Modal.Body>
   
    </Modal>
        </div>
    );
};

export default DeclineModal;

{/* <Button onClick={props.onHide}>Close</Button> */}